import { render } from "./CadastrarMidiaSocial.vue?vue&type=template&id=c1de123a&scoped=true"
import script from "./CadastrarMidiaSocial.vue?vue&type=script&lang=js"
export * from "./CadastrarMidiaSocial.vue?vue&type=script&lang=js"

import "./CadastrarMidiaSocial.vue?vue&type=style&index=0&id=c1de123a&scoped=true&lang=css"

import exportComponent from "I:\\Centrion\\projetos\\aut_fri_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1de123a"]])

export default __exports__